import api from '@/api'
const {$core} = api
export const {$configuration} = $core
